import { put } from "@redux-saga/core/effects";
import { handleError } from "../../../util/errorHandler";
import { setLoading } from "../../reducers/loadingReducer";


export default function* handleLoading(action: any) {
    try {
        yield put(setLoading(action.active));
    } catch (error){
       yield handleError(error)
    }
}
